import React from 'react';
import { LOGIN_PATH } from '../../react-router-paths';
import { useTranslation } from 'react-i18next';
import { TertiaryButtonLink } from '../../feature-auth/reset-password/tertiary-button-link';

interface LoginLinkProps {
    className?: string;
}

export function LoginLink({ className }: LoginLinkProps) {
    const { t } = useTranslation('auth');

    return (
        <TertiaryButtonLink to={LOGIN_PATH} className={className}>
            {t('LoginLink.backToSignIn')}
        </TertiaryButtonLink>
    );
}
